import React from 'react';

const BatteryIcon = ({ className }) => (
  <svg
    width="16"
    height="24"
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.2501 23.6666V20.1666H8.33341L12.4167 14.3333V17.8333H15.3334L11.2501 23.6666ZM1.33341 23.6666C1.00286 23.6666 0.725776 23.5548 0.502165 23.3312C0.278554 23.1076 0.166748 22.8305 0.166748 22.4999V3.83327C0.166748 3.50271 0.278554 3.22563 0.502165 3.00202C0.725776 2.77841 1.00286 2.6666 1.33341 2.6666H3.66675V0.333267H8.33341V2.6666H10.6667C10.9973 2.6666 11.2744 2.77841 11.498 3.00202C11.7216 3.22563 11.8334 3.50271 11.8334 3.83327V11.9999C11.4251 11.9999 11.0265 12.034 10.6376 12.102C10.2487 12.1701 9.86953 12.2722 9.50008 12.4083V4.99993H2.50008V14.3333H6.64175C6.07786 14.9555 5.6355 15.6604 5.31466 16.4479C4.99383 17.2354 4.83341 18.086 4.83341 18.9999C4.83341 19.8944 4.98897 20.7402 5.30008 21.5374C5.61119 22.3347 6.04869 23.0444 6.61258 23.6666H1.33341Z"
      fill="currentColor"
    />
  </svg>
);

export default BatteryIcon;
